var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.count === null || !_vm.service.servers.length)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('errors.noData'))+" ")]):_c('div',{class:['text-h5 color', _vm.colorClass]},[_vm._v(" "+_vm._s(_vm.count)),(_vm.count >= _vm.limit)?_c('span',[_vm._v("+")]):_vm._e()])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }